import { useEffect } from 'react';
import { wearTheme } from '../theme/root';
// Dresses the whole page, navigation and footer included, in a tour's colors while one of the tour's
// views is mounted, and hands the page back to the community's colors on the way out. Null leaves the
// community's colors in place. Keyed on the colors object, so callers pass one that only changes with
// the colors.
export const useTourTheme = (colors) => {
    useEffect(() => colors === null ? undefined : wearTheme(colors), [colors]);
};
export default useTourTheme;
